import { getNavigationUrl } from '../../../utils';
import { Widget } from '../../../apiService';
import Carousel from '../../../Carousel';
import ArtistList from '../../../ArtistList';

const ArtistWidget = ({ widget }: { widget: Widget<'artist_carousel'> }) => {
  const {
    display_title,
    configuration: { items, navigation_configuration },
  } = widget;
  const more = getNavigationUrl(navigation_configuration);

  return (
    <Carousel m={0} title={display_title} more={more}>
      <ArtistList artists={items.map(({ person }) => ({ person, person_role: { title: person.name_en || '' } }))} />
    </Carousel>
  );
};

export default ArtistWidget;
